import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'

/**
 * Import
 * - Components
 */

import Search from '../../../components/pages/Search/Search'

/**
 * Import
 * - Actions
 */
import { fetchSearch } from '../../../actions'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        searchResult: state.search,
    }
}
export default connect(mapStateToProps, {
    fetchSearch: fetchSearch,
})(Search)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Search/Search.tsx